import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { recaptchaAdapterRegistry } from './recaptchaAdapterRegistry';
import { recaptchaRegistry } from './recaptchaRegistry';
import { RECAPTCHA_TOKEN_HEADER } from './utils/constants';
import { initializeDefaultEndpoints } from './recaptchaConfig';

let endpointsInitialized = false;

function ensureEndpointsInitialized(): void {
  if (endpointsInitialized) return;
  initializeDefaultEndpoints();
  endpointsInitialized = true;
}

/**
 * Attach reCAPTCHA interceptor to Axios instance
 *
 * - Skips token injection on SSR
 * - Only injects token for registered endpoints
 * - Uses adapter from registry (supports web/mobile platforms)
 */
export function attachRecaptchaInterceptor(instance: AxiosInstance): void {
  ensureEndpointsInitialized();

  instance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      if (typeof window === 'undefined') return config;

      const adapter = recaptchaAdapterRegistry.getAdapter();
      if (!adapter?.isAvailable()) return config;

      const url = config.url || '';
      const path = url.startsWith('http') ? new URL(url).pathname : url.split('?')[0];

      const action = recaptchaRegistry.getActionForPath(path, config.method);
      if (!action) return config;

      const token = await adapter.getToken(action);
      if (!token) return config;

      config.headers[RECAPTCHA_TOKEN_HEADER] = token;
      return config;
    },
    (error) => Promise.reject(error),
  );
}
